import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const OrganizationIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M19.7778 22V4.22222C19.7778 3.63285 19.5437 3.06762 19.1269 2.65087C18.7102 2.23413 18.1449 2 17.5556 2H6.44444C5.85507 2 5.28984 2.23413 4.8731 2.65087C4.45635 3.06762 4.22222 3.63285 4.22222 4.22222V22M19.7778 22H22M19.7778 22H14.2222M4.22222 22H2M4.22222 22H9.77778M14.2222 22V16.4444C14.2222 16.1498 14.1052 15.8671 13.8968 15.6588C13.6884 15.4504 13.4058 15.3333 13.1111 15.3333H10.8889C10.5942 15.3333 10.3116 15.4504 10.1032 15.6588C9.89484 15.8671 9.77778 16.1498 9.77778 16.4444V22M14.2222 22H9.77778M8.66667 6.44444H9.77778M8.66667 10.8889H9.77778M14.2222 6.44444H15.3333M14.2222 10.8889H15.3333"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

OrganizationIcon.displayName = 'OrganizationIcon';
